import { useQuery } from "react-query";
import { getNavigationLogs } from "../../services/logs/navigation";

export const useNavigationLogs = (filters: any) => {
  return useQuery(
    [JSON.stringify(filters)],
    () => getNavigationLogs(filters),
    {
      keepPreviousData: true,
    }
  );
};